export const SKILLS_LIST = 'skills_list';
export const SKILLS_LIST_SUCCESS = 'skills_list_success';
export const GRADE_LIST = 'grade_list';
export const GRADE_LIST_SUCCESS = 'grade_list_success';

